<template>
  <div class="page">
    <div v-if="!isMobile" class="banner" :style="{backgroundImage:'url('+ websiteInfo.banner +')'}">
      <div class="banner-container">
        <img class="logo" :src="websiteInfo.logo" :style="{height : websiteInfo.logoHeight +'px'}">
      </div>
    </div>
    <div id="mapcontainer" :class="{mobile:isMobile,fullscreen:!websiteInfo.banner}"></div>
    <m-page-loading v-if="isMobile"></m-page-loading>
    <category-filter @filter="categoryFilter" @showArea="isShowAreaPopup = true"/>
    <area-position :map="map" :show.sync="isShowAreaPopup"/>
    <index-intro/>
    <sport-vr-iframe v-if="isShowVrIframe" :show.sync="isShowVrIframe" :src="row.info.url"/>
  </div>
</template>

<script>
/* global BMapGL BMapLib */
import weixin from "@/assets/js/wx";
import chinaPly from "@/assets/js/chinaPly";
import mapJs from '@/assets/js/map';
import configPage from '@/assets/js/configPage';
import mPageLoading from './components/m-page-loading'
import categoryFilter from './components/category-filter'
import areaPosition from './components/area-position'
import indexIntro from './components/index-intro'
import sportVrIframe from '@/pages/components/spot-vr-iframe'

export default {

  name: 'Index',

  components: {categoryFilter, mPageLoading, areaPosition, indexIntro, sportVrIframe},

  provide() {
    return {
      getBoundary: this.getBoundary
    }
  },

  data() {
    return {
      logo: '',
      banner: '',
      map: null,
      categoryId: '',
      worksList: [],
      mapMarkerClusterer: null,
      isShowAreaPopup: false,//手机端-区域弹层
      isShowVrIframe: false,
      row: null,
      zoomLabel: 10,
      zoomRange: [],
      subjectId: this.$route.params.subjectId,
      uiData:null
    };
  },

  computed: {
    worksListFilter() {
      return this.worksList.filter(item => !this.categoryId || item.categoryId.find(cid=>cid == this.categoryId))
    },
    websiteInfo() {
      return this.$store.state.user.websiteInfo || {}
    }
  },

  created() {

  },

  async mounted() {
    this.initPage();
  },

  methods: {

    async initPage() {
      let ui = this.uiData = await configPage.getUi(this.subjectId);
      document.title = ui.title;
      document.querySelector('link[rel="icon"]').href = ui.ico;
      this.zoomLabel = this.isMobile ? ui.zoomMobile : ui.zoom;
      this.zoomLabel = this.zoomLabel || 10;
      this.zoomRange = ui.zoomRange;
      this.loadMap();
      await weixin.setWxConfig({title: ui.title, desc: '', imgUrl: ui.mLogo});
    },

    async loadMap() {
      // await this.utils.loadScript('https://api.map.baidu.com/api?type=webgl&v=3.0&ak=v796wkUHDbujL8YVa7Ntid7s2H3hDcHa&callback=mapOnLoad', 'mapOnLoad');
      // await this.utils.loadScript('https://api.map.baidu.com/api?type=webgl&v=3.0&ak=AaDZJUnlB1kOygmrL1BmSz0ibyKRahNn&callback=mapOnLoad', 'mapOnLoad');
      // await this.utils.loadScript('https://api.map.baidu.com/api?type=webgl&v=3.0&ak=XMrCywX47cLDNlfiVe2akK6YLnYpKiG9&callback=mapOnLoad', 'mapOnLoad');
       await this.utils.loadScript('https://api.map.baidu.com/api?type=webgl&v=3.0&ak=W5IBbZpLZwYgEhpmeINcv5d8JqLtX1iG&callback=mapOnLoad', 'mapOnLoad');
      await this.utils.loadScript('/static/TextIconOverlay_min.js');
      await this.utils.loadScript('/static/MarkerClusterer_min.js');
      this.initMap();
    },

    async initMap() {
      let boundary = (await this.getWorksList()).map(item => new BMapGL.Point(item.lng, item.lat));
      boundary = boundary.length ? boundary : (await this.getInitBoundary());
      this.map = new BMapGL.Map('mapcontainer');
      let center = this.map.getViewport(boundary);
      this.map.setViewport(boundary);
      if(this.isMobile && this.uiData.mInitZoom){
        this.map.setZoom(this.uiData.mInitZoom)
      }
      this.map.setMapStyleV2({styleId: '1c12b94067ec6c5c4d4230d49d0e389d'});
      // this.map.setMapStyleV2({styleId: 'light'});
      this.map.enableScrollWheelZoom();
      this.map.addEventListener('zoomend', this.handleMapZoomEnd);
      this.drawMarkers();
      center.zoom >= this.zoomLabel && this.drawMarkerLabel();
      // if (this.subjectId === "34") {
      //   this.drawRouting()
      // }
    },

    async getInitBoundary() {
      let res = await this.api.subject.info({subjectId: this.subjectId});
      let boundary = [];
      if (res.data.hasInfo == 1) {
        let {province, city, area} = res.data.subjectInfo;
        boundary = await this.getBoundary(`${province}${city}${area}`);
      } else {
        boundary = chinaPly.map(item => new BMapGL.Point(item[0], item[1]));
      }
      return boundary
    },

    //获取地块数据
    async getWorksList() {
      let res = await this.api.works.listsAll({subjectId: this.subjectId});
      this.worksList = res.data;
      return this.worksList
    },

    //切换分类
    categoryFilter(categoryId) {
      this.categoryId = categoryId;
      this.map.clearOverlays();
      this.mapMarkerClusterer.clearMarkers();
      this.worksList.forEach(item => {
        delete item.marker
        delete item.markerLabel
      })
      this.drawMarkers();
      this.map.getZoom() >= this.zoomLabel && this.drawMarkerLabel();
    },

    //行政区边界
    async getBoundary(address) {
      let storageBoundary = mapJs.getStorageBoundary('vyb_area_boundary', address);
      if (storageBoundary) {
        return storageBoundary.map(item => new BMapGL.Point(item.lng, item.lat));
      } else {
        let boundaryGD = await mapJs.getBoundary(address);
        let boundaryBD = mapJs.gaoToBaidu(boundaryGD);
        mapJs.setStorageBoundary('vyb_area_boundary', address, boundaryBD);
        return boundaryBD.map(item => new BMapGL.Point(item.lng, item.lat));
      }
    },

    handleMapZoomEnd() {
      let zoom = this.map.getZoom();
      if (zoom >= this.zoomLabel) {
        this.drawMarkerLabel();
      } else {
        this.worksList.filter(item => item.markerLabel).forEach(item => {
          this.map.removeOverlay(item.markerLabel)
          item.markerLabel = null;
        })
      }
      let zoomMatch = null;
      this.zoomRange.forEach(item => {
        if (zoom >= item.min && zoom <= item.max) {
          zoomMatch = item;
        }
      });
      this.worksList.forEach(item => {
        if (zoomMatch && item.marker.markerPoint) {
          item.marker.markerPoint.setStyle({transform: `translate(-50%,-50%) scale(${zoomMatch.scaleIcon})`});
        }
        if (zoomMatch && item.markerLabel) {
          item.markerLabel.setStyle({transform: `translate(-50%,-50%) scale(${zoomMatch.scaleText})`});
        }
      })

    },

    //绘制-地块-marker
    drawMarkers() {
      let markers = this.worksListFilter
        .filter(item => !item.marker)
        .map(item => {
          let icon = new BMapGL.Icon(item.iconPreview, new BMapGL.Size(1, 1), {imageSize: new BMapGL.Size(1, 1)});
          let marker = new BMapGL.Marker(new BMapGL.Point(item.lng, item.lat), {icon});
          marker.addEventListener('click', () => {
            this.handleClickMarkerAndLabel(item)
          });
          item.marker = marker;
          this.drawMakerPoint(item);
          return marker
        });
      this.mapMarkerClusterer = new BMapLib.MarkerClusterer(this.map, {markers, maxZoom: 8});
    },

    drawMakerPoint(item) {
      let color = item.count || item.type == 2 ? item.color : '#999';
      let html = `<div class="marker-point" style="background:${color}">
                    <div class="icon" style="background-image:url(${item.iconPreview})"></div>
                    <i class="arrow" style="border-top-color:${color}"></i>
                    <div>`;
      html = item.mapType == 2 ?
        `<div class="marker-point-icon"
          style="background-image:url(${item.count || item.type == 2 ? item.iconPreview : item.iconGrayPreview});
          opacity: ${item.count || item.type == 2 ? 1 : 0.7}">
          </div>`
        : html;
      html = item.worksIcon ? `<div class="marker-point-icon"
            style="background-image:url(${item.worksIconPreview});">
          </div>` : html;

      let position = new BMapGL.Point(item.lng, item.lat);
      let label = new BMapGL.Label(html, {position, offset: new BMapGL.Size(0, 0)});
      label.setStyle({
        transform: 'translate(-50%,-50%)',
        'transform-origin': 'center bottom',
        transition: 'transform 0.3s ease',
        border: 'none',
        background: 'none'
      });
      label.addEventListener('click', () => {
        this.handleClickMarkerAndLabel(item)
      });
      item.marker.markerPoint = label;
    },

    drawMarkerLabel() {
      this.worksListFilter
        .filter(item => !item.markerLabel)
        .forEach(item => {
          let html = `<div style="cursor: pointer">${item.name}<div>`;
          let position = new BMapGL.Point(item.lng, item.lat);
          let label = new BMapGL.Label(html, {position, offset: new BMapGL.Size(0, 26)});
          let color = item.count || item.type == 2 ? (item.worksColor || item.color) : '#999';
          label.setStyle({
            transform: 'translate(-50%,-50%)',
            'transform-origin': 'center top',
            transition: 'transform 0.3s ease',
            border: 'none',
            background: 'none',
            color, fontSize: '12px'
          });
          label.addEventListener('click', () => {
            this.handleClickMarkerAndLabel(item)
          });
          item.markerLabel = label;
          this.map.addOverlay(label);
        })
    },

    handleClickMarkerAndLabel(row) {
      if (row.type == 2) {
        this.isShowVrIframe = true;
        this.row = row;
        return
      }
      if (row.count == 0) {
        return
      }
      let subjectId = this.subjectId;
      this.$store.commit('preview/UPDATE_FROM_INDEX_MAP', true);
      this.$router.push({path: `/preview?id=${row.id}${subjectId ? '&subjectId=' + subjectId : ''}`});
    },

    //绘制路线
    drawRouting() {
      const colors = ['#f00','#ff8000','#449855','#809AE9','#6C277B'];
      const adds = [
        [
          {name: "市委党校", lng: 120.90769721322704, lat: 31.409604864393554},
          {name: "博士路、祖冲之路交叉口", lng: 120.9004222386389, lat: 31.408482146722676},
          {name: "祖冲之路、相石路交叉口", lng: 120.88696300873481, lat: 31.496319483565507},
          {name: "相石路、升光路交叉口", lng: 120.92470826953833, lat: 31.501186834458913},
          {name: "升光路、兆良路", lng: 120.92372850168306, lat: 31.510610099971334},
          {name: "202乡道、窑石线交叉口", lng: 120.91909304258881, lat: 31.516638768886562},
          {name: "华社村港池码头", lng: 120.92160620771124, lat: 31.520172345727296},
        ],
        [
          {name: "窑石线、202乡道交叉口", lng: 120.9190930425888, lat: 31.516638768886562},
          {name: "兆良路、升光路", lng: "120.92372850168306", lat: "31.510610099971334"},
          {name: "升光路、中华园路", lng: "120.92402771223131", lat: "31.50695985753434"},
          {name: "中华园路、长江路交叉口", lng: "120.95036156517214", lat: "31.50853093178208"},
          {name: "长江路、兰泾路交叉口", lng: "120.97954799334349", lat: "31.447026576643527"},
          {name: "兰泾路、昆北路", lng: "120.96104676558265", lat: "31.446588265417464"},
          {name: "昆北路、融汇路", lng: "120.9610549847216", lat: "31.438966560454087"},
          {name: "融汇路、紫竹路", lng: "120.96652637418424", lat: "31.439320309780964"},
          {name: "高新区新乐村", lng: "120.96662919448987", lat: "31.43805226721233"},
        ],
        [
          {name: "高新区新乐村", lng: "120.96662919448987", lat: "31.43805226721233"},
          {name: "富士康路、长江路", lng: "120.9844150540049", lat: "31.421973348968958"},
          {name: "长江路、长丰路", lng: "120.9663425839133", lat: "31.269078833817595"},
          {name: "长丰路、金丰路", lng: "120.97678425544815", lat: "31.2694289732403"},
          {name: "苏州华绚园艺有限公司", lng: "120.97540250221874", lat: "31.26858018170704"},
        ],
        [
          // {name: "金丰路、长丰路", lng: "120.97678425544815", lat: "31.2694289732403"},
          // {name: "长丰路、长江路", lng: "120.9663425839133", lat: "31.269078833817595"},
          {name: "长江路、阳光中路", lng: "120.96431966706047", lat: "31.28011214566941"},
          {name: "阳光中路、古城路", lng: "120.90640625343042", lat: "31.284776120611628"},
          {name: "古城路、129村道", lng: "120.90592068057248", lat: "31.20990279278044"},
          {name: "长云村长娄里", lng: "120.90527615754635", lat: "31.21353244602441"},
        ],
        [
          {name: "古城路", lng: "120.90842854160725", lat: "31.21454874154326"},
          {name: "古城路、博士路", lng: "120.88564554764062", lat: "31.405703640664537"},
          {name: "市委党校", lng: "120.90769721322704", lat: "31.409604864393554"},
        ]
      ]
      adds.forEach((add,addIndex) => {
        add.forEach((item, index) => {
          if (index > 0) {
            const start = new BMapGL.Point(add[index - 1].lng, add[index - 1].lat);
            const end = new BMapGL.Point(add[index].lng, add[index].lat);
            this.drivingRoute(start, end,colors[addIndex])
          }
        })
      })
    },


    drivingRoute(start, end,color) {
      const driving = new BMapGL.DrivingRoute(this.map, {
        renderOptions: {
          map: this.map,
          autoViewport: false
        }
      });

      driving.search(start, end);
      driving.setMarkersSetCallback((pois) => {
        this.map.removeOverlay(pois[0].marker)
        this.map.removeOverlay(pois[1].marker)
      })
      driving.setPolylinesSetCallback(routes=>{
        routes[0]._polyline.setStrokeColor(color)
      })
    }

  }
}
;
</script>

<style scoped>
#mapcontainer {
  position: absolute !important;
  top: 80px;
  left: 0;
  right: 0;
  bottom: 0
}

#mapcontainer.fullscreen {
  top: 0;
}

#mapcontainer.mobile {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0
}

.page {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}


.banner {
  height: 80px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.banner-container {
  height: 100%;
  display: flex;
  align-items: center;
}

.banner-container .logo {
  display: block;
  height: 40px;
  margin-left: 20px;
}

::v-deep .marker-point {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 100%;
  position: relative;
}

::v-deep .marker-point-icon {
  cursor: pointer;
  width: 28px;
  height: 28px;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
}

::v-deep .marker-point:after {
  content: "";
  position: absolute;
  width: 22px;
  height: 22px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 100%;
  border: 1px solid #fff;
}

::v-deep .marker-point .arrow {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, 62%);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #000;
}

::v-deep .marker-point .icon {
  width: 16px;
  height: 16px;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
}

</style>
